// DataDeletionStatusPage.tsx — (tf3-34b; Part B §7.5) /data-deletion/:code, public: the status of a data-deletion request
// Meta's data-deletion callback answered with (its `url`). Reads the package's GET /api/publishing/callbacks/deletion-status/:code.
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiGet } from "@/api/client.ts";
import { deletionWords, statusLabel, UNKNOWN_CODE, type DeletionStatus } from "@/lib/deletion-status.ts";
import { DELETION_STATUS_ABOUT, DELETION_STATUS_QUESTIONS } from "./legal-text.ts";

export function DataDeletionStatusPage() {
  const { code = "" } = useParams();
  const [s, setS] = useState<DeletionStatus | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [unknown, setUnknown] = useState(false);
  useEffect(() => {
    apiGet<DeletionStatus>(`/publishing/callbacks/deletion-status/${encodeURIComponent(code)}`).then(setS)
      .catch((e) => { if ((e as { status?: number }).status === 404) setUnknown(true); else setErr(`The status couldn't be read: ${String((e as Error)?.message ?? e)}`); });   // catch-reason: shown in place of the status
  }, [code]);
  // (B120-1; D3, Meta's rule) the page says in words what happened, and why when nothing was deleted
  const label = s ? statusLabel(s) : unknown ? "No data found for this request" : null;
  const why = s ? (s.status === "received" ? DELETION_STATUS_ABOUT : s.status === "failed" ? `${DELETION_STATUS_ABOUT} ${deletionWords(s).line}` : deletionWords(s).line) : unknown ? UNKNOWN_CODE : null;
  return (
    <section style={{ maxWidth: 640, margin: "0 auto", padding: "64px 20px" }}>
      <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#ff5b1f" }}>Data deletion</p>
      <h1 style={{ fontSize: 28, fontWeight: 800, margin: "8px 0" }}>Deletion request {code}</h1>
      {!label && !err && <p>Reading…</p>}
      {err && <p>{err}</p>}
      {label && <>
        <p><strong>Status: {label}.</strong></p>
        <p>{why}</p>
        {s && <p style={{ fontSize: 13, color: "#6b6b6b", marginTop: 16 }}>Received {new Date(s.receivedAt).toLocaleString()}
          {s.doneAt ? ` · finished ${new Date(s.doneAt).toLocaleString()}` : ""}</p>}
        <p>{DELETION_STATUS_QUESTIONS}</p>
      </>}
    </section>
  );
}
